import axios from "axios";
import { useState } from "react";
import { useForm } from "react-hook-form";
import { toast } from "react-toastify";
import {
  Modal,
  Box,
  TextField
} from "@mui/material";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faClose } from "@fortawesome/free-solid-svg-icons";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

export const SeasonNoticeAndNewsletter = ({
  newsletterPage
}) => {

  const { register, handleSubmit, reset } = useForm();
  const { register: unregister, handleSubmit: handleUnsubscribe, reset: resetUnsubscribe } = useForm();

  const [isLoading, setIsLoading] = useState(false);
  const [unsubscribeLoading, setUnsubscribeLoading] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const navigate = useNavigate();
  const { t } = useTranslation();
  const noticeText = t("Newsletter.noticeText");
  const newsletterText = t("Newsletter.newsletterText");
  const buttonText = t("Newsletter.buttonText");
  const placeholder = t("Newsletter.placeholder");

  const onSubmit = async (data) => {
    setIsLoading(true);
    try {
      await axios.post("/api/newsletter", { email: data.email });
      toast.success(t("Newsletter.successMessage"));
      navigate("/thank-you-newsletter");
      reset();
    } catch (err) {
      toast.error(
        err.response?.data?.message ||
        err.response?.data?.error ||
        t("Newsletter.errorMessage")
      );
    }
    setIsLoading(false);
  };


  const onUnsubscribe = async (data) => {
    setUnsubscribeLoading(true);
    try {
      await axios.delete("/api/newsletter/unsubscribe", {
        data: { email: data.email }
      });
      toast.success(t("Newsletter.unsubscribeSuccess"));
      resetUnsubscribe();
      setOpenModal(false);
    } catch (err) {
      toast.error(
        err.response?.data?.message ||
        err.response?.data?.error ||
        t("Newsletter.unsubscribeError")
      );
      setOpenModal(false);
    }
    setUnsubscribeLoading(false);
  };

  return (
    <div className="mx-1">
      {!newsletterPage && (
        <p className="text-[#8C0000] text-2xl font-cormorant-normal-important mb-2">
          {noticeText}
        </p>
      )}
      <div className="flex flex-col lg:flex-row lg:justify-between lg:items-start bg-[#CCC] p-3 gap-4">
        <p className="text-lg lg:text-xl text-white text-center lg:text-left pl-3 mt-2">
          {newsletterText}
        </p>
        <div>
          <form
            className="flex flex-col lg:flex-row gap-2 w-full lg:w-auto"
            onSubmit={handleSubmit(onSubmit)}
          >
            <div>
              <input
                className="px-4 py-2 w-full lg:w-72 lg:py-1 text-base lg:text-lg flex-1 sm:flex-none h-10"
                {...register("email", { required: true })}
                placeholder={placeholder}
                type="email"
              />

              {newsletterPage && (
                <div
                  className="text-sm mt-1 text-white w-fit hover:cursor-pointer hover:text-[#6f6f6f]"
                  onClick={() => setOpenModal(true)}
                >
                  {t("Newsletter.clickHere")}
                </div>
              )}
            </div>

            <button
              type="submit"
              disabled={isLoading}
              className="text-white bg-opera-red px-4 py-2 lg:px-6 lg:py-2 rounded whitespace-nowrap h-10"
            >
              {buttonText}
            </button>
          </form>
        </div>
      </div>

      <Modal open={openModal} onClose={() => setOpenModal(false)}>
        <Box
          sx={{
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: 360,
            bgcolor: "background.paper",
            borderRadius: 2,
            boxShadow: 24,
            p: 4,
            position: "relative",
          }}
        >
          <FontAwesomeIcon icon={faClose} className="absolute top-4 right-4 cursor-pointer text-gray-700 hover:cursor-pointer" onClick={() => setOpenModal(false)} />
          <h2 className="text-lg">
            {t("Newsletter.modalHeading")}
          </h2>
          <form onSubmit={handleUnsubscribe(onUnsubscribe)}>
            <TextField
              {...unregister("email", { required: true })}
              fullWidth
              margin="normal"
              label={t("Newsletter.placeholder")}
              type="email"
              size="small"
            />
            <button
              type="submit"
              disabled={unsubscribeLoading}
              className="bg-[#8C0000] px-4 py-2 lg:px-6 lg:py-2 rounded text-white w-full mt-2"
            >
              {unsubscribeLoading ? t("Newsletter.unsubscribing") : t("Newsletter.unsubscribe")}
            </button>
          </form>
        </Box>
      </Modal>
    </div>
  );
};
